import React from "react";
import {ClickableText} from "../../components/custom-common";

export const BackupCodeButton = ({ handleUseMethod }) => {

  return (
    <ClickableText
      onClick={handleUseMethod}
      small
    >
      Or, use a backup code
    </ClickableText>
  )
}
